import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSinaweiboComponent } from './simple-icons-sinaweibo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSinaweiboComponent ],
    exports:      [ SimpleIconsSinaweiboComponent ],
    bootstrap:    []
})
export class SimpleIconsSinaweiboModule {}
